// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export default function SocialAuthButtons({ mode = "login" }) {
    const { t } = useTranslation();

    const startGoogle = () => {
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    const comingSoon = (name) => () => {
        toast.info(t("social_auth.coming_soon", { provider: name }));
    };

    const isRegister = mode === "register";
    const labelGoogle = isRegister ? t("social_auth.signup_google") : t("social_auth.continue_google");
    const labelApple = isRegister ? t("social_auth.signup_apple") : t("social_auth.continue_apple");
    const labelMeta = isRegister ? t("social_auth.signup_meta") : t("social_auth.continue_meta");

    return (
        <div className="space-y-2.5" data-testid="social-buttons">
            <button
                onClick={startGoogle}
                data-testid="btn-google-auth"
                className="w-full rounded-full bg-white text-black py-3.5 font-semibold flex items-center justify-center gap-2.5 active:scale-[0.98] transition"
            >
                <GoogleIcon />
                {labelGoogle}
            </button>
            <button
                onClick={comingSoon("Apple")}
                data-testid="btn-apple-auth"
                className="w-full rounded-full bg-foreground text-background py-3.5 font-semibold flex items-center justify-center gap-2.5 opacity-70 active:scale-[0.98] transition"
            >
                <AppleIcon />
                {labelApple}
                <span className="text-[10px] font-bold bg-background/20 px-1.5 py-0.5 rounded-full ml-1">{t("social_auth.soon_badge")}</span>
            </button>
            <button
                onClick={comingSoon("Meta")}
                data-testid="btn-meta-auth"
                className="w-full rounded-full bg-[#1877F2] text-white py-3.5 font-semibold flex items-center justify-center gap-2.5 opacity-70 active:scale-[0.98] transition"
            >
                <MetaIcon />
                {labelMeta}
                <span className="text-[10px] font-bold bg-white/20 px-1.5 py-0.5 rounded-full ml-1">{t("social_auth.soon_badge")}</span>
            </button>
        </div>
    );
}

function GoogleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
    );
}

function AppleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M17.05 12.04c-.03-3.14 2.57-4.65 2.69-4.72-1.47-2.14-3.75-2.44-4.56-2.47-1.94-.2-3.79 1.14-4.78 1.14-.99 0-2.52-1.12-4.15-1.09-2.13.03-4.1 1.24-5.2 3.15-2.22 3.85-.57 9.55 1.6 12.67 1.06 1.52 2.32 3.23 3.96 3.17 1.59-.06 2.19-1.03 4.11-1.03 1.92 0 2.47 1.03 4.15.99 1.71-.03 2.8-1.56 3.85-3.09 1.21-1.78 1.71-3.5 1.74-3.59-.04-.02-3.34-1.28-3.37-5.08zM13.83 2.8c.88-1.07 1.48-2.56 1.31-4.04-1.27.05-2.81.85-3.73 1.92-.82.95-1.54 2.47-1.35 3.93 1.42.11 2.87-.72 3.77-1.81z"/>
        </svg>
    );
}

function MetaIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M9.1 20.4h3.1v-7.2h2.5l.4-3.1h-2.9V8.4c0-.9.2-1.5 1.5-1.5h1.6V4.1c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.2H6.6v3.1h2.5v7.1z"/>
        </svg>
    );
}
